import React, { useCallback, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import {
  mapDispatchToPropsManagement,
  mapStateToPropsManagement,
  mapToStateToPropsParticipant,
} from "../../../modules/profileManagement";
import { ProfileCard } from "../../ui-library/ProfileCard/ProfileCard";
import "./ParticipantUsers.css";
import { getFormattedDate } from "../../../modules/utils";
import { withTheme } from "styled-components";
import { TablePopover } from "../../ui-library/TablePopover/TablePopover";
import DefaultTable, {
  Filter,
  Line,
} from "../../ui-library/CustomTable/DefaultTable";
import AccountStatus from "../../library/AccountStatus/AccountStatus";
import { UserStatus } from "../../library/AccountStatus/AccountStatus.constants";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";
import ConfirmRequest from "../../library/ConfirmRequest/ConfirmRequest";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../ui-library/CustomDropdown/CustomDropdown";

export const ParticipantUsers = (props) => {
  const {
    participantUsers,
    fetchParticipantUsers,
    blockUnblockUser,
    canBlockParticipant,
    totalitems,
    searchedParams,
    theme,
    loading,
  } = props;

  const { t } = useTranslation();

  const [blockConfirmRequest, setBlockConfirmRequest] = useState(null);

  const getData = useCallback(
    (params) => {
      fetchParticipantUsers(params);
    },
    [fetchParticipantUsers]
  );

  useEffect(() => {
    if (totalitems === null) {
      getData(searchedParams);
    }
  }, [fetchParticipantUsers, totalitems, getData, searchedParams]);

  // Load block / unblock dropdowns
  const verifyLockUnlockDropdowns = (user) => {
    return canBlockParticipant && user.status === UserStatus.ACTIVE.id ? (
      <Dropdown.Item
        key="1"
        onSelect={() => setBlockConfirmRequest(user.userName)}
      >
        {t("appText.participantUsers.blockUser")}
      </Dropdown.Item>
    ) : canBlockParticipant && user.status === UserStatus.BLOCKED.id ? (
      <Dropdown.Item
        key="2"
        onSelect={() => {
          blockUnblockUser(user.userName, false).then(() => {
            getData();
          });
        }}
      >
        {t("appText.participantUsers.unblockUser")}
      </Dropdown.Item>
    ) : null;
  };

  const defaultProps = {
    headers: [
      { label: t("appText.participantUsers.site") },
      { label: t("appText.participantUsers.participantId") },
      { label: t("appText.participantUsers.study") },
      { label: t("appText.participantUsers.dateSignedUp") },
      { label: t("appText.participantUsers.lastLogin") },
      { label: t("appText.participantUsers.accountStatus") },
      { label: t("appText.participantUsers.options") },
    ],
    maincolor: theme.success,
    totalitems,
    hasSearch: 1,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    loading,
    getData,
  };

  const changeFilterBy = (filter) => {
    const params = {
      ...searchedParams,
      page: 0,
      filter: filter.id,
    };

    getData(params);
  };

  const confirmBlockRequestHandler = () => {
    blockUnblockUser(blockConfirmRequest, true).then(() => {
      getData();
    });

    setBlockConfirmRequest(null);
  };

  return (
    <div
      data-testid="participant-users"
      className="mt-5"
      style={{ paddingTop: "2em", position: "relative" }}
    >
      <div className="mb-5">
        <ProfileCard
          title={t("appText.participantUsers.header.participantInformation")}
          cardHeader="card-admin-header-separator-green"
          iconClassName="fas fa-users-cog"
        >
          <CustomModal
            title={t("appText.participantUsers.areYouSure")}
            onClose={() => setBlockConfirmRequest(false)}
            show={!!blockConfirmRequest}
          >
            <ConfirmRequest
              message={t("appText.participantUsers.blockUserConfirm")}
              onConfirm={confirmBlockRequestHandler}
              onClose={() => setBlockConfirmRequest(false)}
            />
          </CustomModal>

          <DefaultTable {...{ ...defaultProps }}>
            <Filter>
              <form className="form-inline mb-1 justify-content-start">
                {t("appText.participantUsers.status")}

                <CustomDropdown
                  className="ml-2"
                  placeholder={UserStatus.ALL.value}
                  values={Object.values(UserStatus).filter(
                    (item) =>
                      item.value.toLowerCase() !==
                      UserStatus.INVITED.value.toLowerCase()
                  )}
                  onChange={(e) => changeFilterBy(e)}
                />
              </form>
            </Filter>
            {participantUsers.map((user, index) => (
              <Line key={`user-entry-${index}`}>
                <span>{user.site}</span>
                <span>{user.name || user.userName || "-"}</span>
                <span>
                  <TablePopover description="Studies" data={user.studies} />
                </span>
                <span>{getFormattedDate(user.created)}</span>
                <span>{getFormattedDate(user.lastlogin)}</span>

                <AccountStatus>{user.status}</AccountStatus>

                {user.status === UserStatus.ACTIVE.id ||
                user.status === UserStatus.BLOCKED.id ? (
                  <TableDropDown>
                    {[verifyLockUnlockDropdowns(user)]}
                  </TableDropDown>
                ) : null}
              </Line>
            ))}
          </DefaultTable>
        </ProfileCard>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsManagement(state),
    ...mapToStateToPropsParticipant(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToPropsManagement
)(withTheme(ParticipantUsers));
